import React, { useEffect, useState, useRef } from "react";
import { useStopwatch } from "react-timer-hook";
import { useNavigate } from "react-router-dom";
import "./callmoduleassets/styles/dialer2.css";
import Draggable from "react-draggable";
import { toast } from "react-toastify";
import { configuration } from "./web";
import SockJS from "sockjs-client";
import Stomp from "stompjs";
import axios from "axios";
import voiceIcon from "./callmoduleassets/images/voice.png";
import {
  BaseUrl,
  VoiceDomainName,
  VoiceDomainNamePure,
} from "../../container/BaseUrl/BaseUrl";
import soundfile from "./callmoduleassets/ringsound/telephone_ring.mp3";
import "./callmoduleassets/AWL-min/awl.min.js";
import { connect } from "react-redux";
import {
  setSkillSet,
  setDialedNumberInc,
  setagentDialedNumber,
  setshowphonedialer,
  setShowphonedialer2,
  setShowphonedialer3,
  setshowIncommingscreen,
  setcallscreen,
  setshowIncommingNxtscreen,
  setcalledagentscreen,
  setconfrencescreen,
  setShowMute,
  setShowUnMute,
  setAgentShowMute,
  setAgentShowUnMute,
  setShowHold,
  setShowUnHold,
  setagentCallHold,
  setagentCallUnHold,
  setTransferCall,
  setmakingTransferCall,
  setConfrence,
  setMergeCall,
  setcontactId,
  setconsultedContactId,
  setCallId,
  setAcceptChatActive,
  setExternalChatData,
  setVoiceSessionId,
  setvoiceseconds,
  setvoiceminutes,
  setvoicehours,
  setsidebarVal,
  setShowNotification,
  setShowUserProfile,
  setChatRefresh,
  setShowVoiceCall,
  setShowingStatusClass,
  setShowingStatus,
  setShowingStatusVoice,
  updateNotification,
  setReadyButton,
  setshowExternalChat,
  setcontactlist,
} from "../../redux/actions/actions";
import EndChatModel from "../chat-components/Chat-component/chat-component-model/End-chat-model.js";
import EndChatModelForPopCall from "../chat-components/Chat-component/chat-component-model/End-chat-model-for-popCall.jsx";
const mapStateToProps = (state) => {
  return {
    skillset: state.data.skillset,
    dailedNumberInc: state.data.dailedNumberInc,
    agentDialedNumber: state.data.agentDialedNumber,
    showphonedialer: state.data.showphonedialer,
    showphonedialer2: state.data.showphonedialer2,
    showphonedialer3: state.data.showphonedialer3,
    showIncommingscreen: state.data.showIncommingscreen,
    callscreen: state.data.callscreen,
    showIncommingNxtscreen: state.data.showIncommingNxtscreen,
    calledagentscreen: state.data.calledagentscreen,
    confrencescreen: state.data.confrencescreen,
    showMute: state.data.showMute,
    showUnMute: state.data.showUnMute,
    agentshowMute: state.data.agentshowMute,
    agentshowUnMute: state.data.agentshowUnMute,
    showHold: state.data.showHold,
    showUnHold: state.data.showUnHold,
    agentCallHold: state.data.agentCallHold,
    agentCallUnHold: state.data.agentCallUnHold,
    transferCall: state.data.transferCall,
    makingTransferCall: state.data.makingTransferCall,
    confrence: state.data.confrence,
    mergecall: state.data.mergecall,
    contactId: state.data.contactId,
    consultedContactId: state.data.consultedContactId,
    callId: state.data.callId,
    showStatusChannel: state.data.showStatusChannel,
    voiceseconds: state.data.voiceseconds,
    voiceminutes: state.data.voiceminutes,
    voicehours: state.data.voicehours,
    showIncommingscreen: state.data.showIncommingscreen,
    skillset: state.data.skillset,
    chat: state.data.chat,
    voiceseconds: state.data.voiceseconds,
    voiceminutes: state.data.voiceminutes,
    voicehours: state.data.voicehours,
    chat: state.data.chat,
    showingStatusVoice: state.contactListData.showingStatusVoice,
    selectedmobile: state.data.selectedmobile,
  };
};

const Sdk = (props) => {
  const {
    skillset,
    dailedNumberInc,
    showphonedialer,
    showIncommingscreen,
    contactId,
    setSkillSet,
    setDialedNumberInc,
    setshowphonedialer,
    setShowphonedialer2,
    setShowphonedialer3,
    setshowIncommingscreen,
    setcallscreen,
    setshowIncommingNxtscreen,
    setcalledagentscreen,
    setconfrencescreen,
    setShowMute,
    setShowUnMute,
    setShowHold,
    setShowUnHold,
    setagentCallHold,
    setagentCallUnHold,
    setTransferCall,
    setmakingTransferCall,
    setConfrence,
    setMergeCall,
    setcontactId,
    setconsultedContactId,
    setCallId,
    setShowVoiceCall,
    dailedNumber,
    setDialedNumber,
  } = props;

  const { seconds, minutes, hours, start, pause, reset } = useStopwatch({
    autoStart: false,
  });

  props.setvoiceseconds(seconds);
  props.setvoiceminutes(minutes);
  props.setvoicehours(hours);

  localStorage.setItem("callduration", `${hours}:${minutes}:${seconds}`);

  const [spinner, setSpinner] = useState(false);
  const AvcUrl = localStorage.getItem("AvcUrl");
  const [externalContactId, setexternalContactId] = useState("");
  const [calledDeviceID, setcalledDeviceID] = useState("");
  const [callingAgentName, setcallingAgentName] = useState("");
  const avayaplatform = "AACC";
  const navigate = useNavigate();
  let agentLoginTerminalId = localStorage.getItem("agentLoginTerminalId");

  const [endchatModalDialog, setendchatModalDialog] = useState(false);
  const closeModel = () => {
    setendchatModalDialog(false);
  };
  const myRef = useRef();

  const playRingSound = () => {
    if (myRef.current) {
      myRef.current.play();
    }
  };
  const pauseRingSound = () => {
    if (myRef.current) {
      myRef.current.pause();
    }
  };

  useEffect(() => {
    initiateWebSocket();
    if (localStorage.getItem("EnableWEBRTC")) {
      configuration();
    }
  }, []);

  var stompClient;
  const initiateWebSocket = () => {
    let ssToken = localStorage.getItem("ssoToken");
    const customHeaders = {
      terminal: ssToken, //ssoToken
    };

    let socket = new SockJS(AvcUrl + "/ws");
    stompClient = Stomp.over(socket);

    stompClient.connect(customHeaders, onConnected, onError);
  };
  var i = 0;
  const onConnected = () => {
    stompClient.subscribe("/user/terminal/messages", (payload) => {
      const responseData = JSON.parse(payload.body);
      if (responseData.event == "RINGING") {
        console.log("RINGING", responseData);
        playRingSound();
        if (responseData.callType == "Inbound") {
          localStorage.setItem("callActivate", "true");
          setshowphonedialer(false);
          localStorage.setItem("callAttend", "false");
          setDialedNumberInc(
            responseData.callingDeviceID != null
              ? responseData.callingDeviceID
              : responseData.callerId
          );
          localStorage.setItem(
            "incomingNumber",
            responseData.callingDeviceID != null
              ? responseData.callingDeviceID
              : responseData.callerId
          );
          setSkillSet(responseData.skillSet);
          CustomerNameApi(
            responseData.callingDeviceID != null
              ? responseData.callingDeviceID
              : responseData.callerId
          );
          localStorage.setItem("contactId", responseData.contactId);
          setcontactId(responseData.contactId);
          setshowIncommingscreen(true);
          setshowphonedialer(false);
          setexternalContactId(responseData.externalContactId);
          setcalledDeviceID(responseData.calledDeviceID);
          setcallingAgentName(responseData.callingDeviceID);
        } else if (responseData.callType == "Outbound") {
          localStorage.setItem("callActivate", "true");
          setshowphonedialer(false);
          localStorage.setItem("callType", responseData.callType);
          localStorage.setItem("callAttend", "false");
          setDialedNumberInc(
            responseData.callingDeviceID != null
              ? responseData.callingDeviceID
              : responseData.callerId
          );
          CustomerNameApi(
            responseData.callingDeviceID != null
              ? responseData.callingDeviceID
              : responseData.callerId
          );
          setcontactId(responseData.contactId);
          localStorage.setItem("contactId", responseData.contactId);
          setSkillSet(responseData.skillSet);
          setshowIncommingscreen(true);
          setshowphonedialer(false);
          setexternalContactId(responseData.externalContactId);
          setcalledDeviceID(responseData.calledDeviceID);
          setcallingAgentName(responseData.callingDeviceID);
        } else if (responseData.callType == "ConsultConference") {
          localStorage.setItem("callActivate", "true");
          localStorage.setItem("callAttend", "false");
          setshowphonedialer(false);
          setDialedNumberInc(
            responseData.callingDeviceID != null
              ? responseData.callingDeviceID
              : responseData.callerId
          );
          CustomerNameApi(
            responseData.callingDeviceID != null
              ? responseData.callingDeviceID
              : responseData.callerId
          );
          setcontactId(responseData.contactId);
          localStorage.setItem("agenttransConf", true);
          localStorage.setItem("contactId", responseData.contactId);
          localStorage.setItem("transfercontactId", responseData.contactId);
          localStorage.setItem("mainContactId", responseData.mainContactId);
          setSkillSet(responseData.skillSet);
          setshowIncommingscreen(true);
          setshowphonedialer(false);
          setexternalContactId(responseData.externalContactId);
          setcalledDeviceID(responseData.calledDeviceID);
          setcallingAgentName(responseData.callingDeviceID);
        }
      }
      if (responseData.event == "ACTIVE") {
        console.log("ACTIVE", responseData);
        pauseRingSound();
        if (responseData.callType == "Inbound") {
          console.log("responseData", responseData);
          if (responseData.reason == "CONFERENCE_COMPLETE") {
            setDialedNumberInc(responseData.callerId);
            tranferConferanceUpdate(responseData.callerId);
            console.log("conferance who made");
            localStorage.setItem("InConferance", true);
            localStorage.removeItem("agentcallType");
            localStorage.removeItem("agentcontactid");
            setconfrencescreen(true);
            setshowIncommingNxtscreen(false);
            setcalledagentscreen(false);
            setShowHold(false);
            setShowUnHold(false);
            setTransferCall(false);
            setmakingTransferCall(false);
            setConfrence(false);
            setMergeCall(false);
            setShowphonedialer2(false);
            setShowphonedialer3(false);
          } else if (responseData.reason == "TRANSFER_COMPLETE") {
            setshowIncommingscreen(false);
            setcallscreen(true);
            setshowIncommingNxtscreen(true);
            setcalledagentscreen(false);
            setShowMute(true);
            setShowUnMute(false);
            setShowHold(true);
            setShowUnHold(false);
            setagentCallUnHold(false);
            setTransferCall(true);
            setmakingTransferCall(false);
            setConfrence(true);
            setMergeCall(false);
            setDialedNumberInc(responseData.callerId);
            tranferConferanceUpdate(responseData.callerId);
          } else {
            if (responseData.uuiData == "Transfer") {
              if (localStorage.getItem("agentcallType") == "transfer") {
                setcallscreen(true);
                setshowIncommingNxtscreen(true);
                setcalledagentscreen(true);
                setShowHold(true);
                setShowUnHold(false);
                setTransferCall(false);
                setmakingTransferCall(true);
                setConfrence(false);
                setMergeCall(false);
              } else if (
                localStorage.getItem("agentcallType") == "conferance"
              ) {
                setcallscreen(true);
                setshowIncommingNxtscreen(true);
                setcalledagentscreen(true);
                setShowHold(true);
                setShowUnHold(false);
                setTransferCall(false);
                setmakingTransferCall(false);
                setConfrence(false);
                setMergeCall(true);
              } else {
                // setDialedNumberInc(responseData.callingDeviceID)
                setcallscreen(true);
                setshowIncommingNxtscreen(true);
                setShowMute(true);
                setShowUnMute(false);
                setShowHold(true);
                setShowUnHold(false);
                setagentCallUnHold(false);
                setTransferCall(true);
                setmakingTransferCall(false);
                setConfrence(true);
                setMergeCall(false);
                setcalledagentscreen(false);
                setconfrencescreen(false);
              }
            } else {
              setSpinner(false);
              setShowVoiceCall(true);
              setshowphonedialer(false);
              setcontactId(responseData.contactId);
              localStorage.setItem("contactId", responseData.contactId);
              setshowIncommingscreen(false);
              setcallscreen(true);
              setshowIncommingNxtscreen(true);
              setShowMute(true);
              setShowUnMute(false);
              setShowHold(true);
              setShowUnHold(false);
              setagentCallUnHold(false);
              setTransferCall(true);
              setmakingTransferCall(false);
              setConfrence(true);
              setMergeCall(false);
              setcalledagentscreen(false);
              setconfrencescreen(false);
              if (localStorage.getItem("callActivate") == "true") {
                props.setinvoice(true);
                updateStatus("InCall");
                createVoiceSession(responseData);
                localStorage.setItem("callAttend", "true");
                localStorage.setItem("callActivate", "false");
                reset();
                start();
                CallArrivaltime();
              }
            }
          }
        } else if (responseData.callType == "Outbound") {
          if (localStorage.getItem("callpresent") == "true") {
            localStorage.setItem("callActivate", "true");
          }
          if (responseData.reason == "CONFERENCE_COMPLETE") {
            setDialedNumberInc(responseData.callerId);
            tranferConferanceUpdate(responseData.callerId);
            console.log("conferance who made");
            localStorage.setItem("InConferance", true);
            localStorage.removeItem("agentcallType");
            localStorage.removeItem("agentcontactid");
            setconfrencescreen(true);
            setshowIncommingNxtscreen(false);
            setcalledagentscreen(false);
            setShowHold(false);
            setShowUnHold(false);
            setTransferCall(false);
            setmakingTransferCall(false);
            setConfrence(false);
            setMergeCall(false);
            setShowphonedialer2(false);
            setShowphonedialer3(false);
          } else if (responseData.reason == "TRANSFER_COMPLETE") {
            setshowIncommingscreen(false);
            setcallscreen(true);
            setshowIncommingNxtscreen(true);
            setcalledagentscreen(false);
            setShowMute(true);
            setShowUnMute(false);
            setShowHold(true);
            setShowUnHold(false);
            setagentCallUnHold(false);
            setTransferCall(true);
            setmakingTransferCall(false);
            setConfrence(true);
            setMergeCall(false);
            setDialedNumberInc(responseData.callerId);
            tranferConferanceUpdate(responseData.callerId);
          } else {
            if (responseData.uuiData == "Transfer") {
              if (localStorage.getItem("agentcallType") == "transfer") {
                setcallscreen(true);
                setshowIncommingNxtscreen(true);
                setcalledagentscreen(true);
                setShowHold(true);
                setShowUnHold(false);
                setTransferCall(false);
                setmakingTransferCall(true);
                setConfrence(false);
                setMergeCall(false);
              } else if (
                localStorage.getItem("agentcallType") == "conferance"
              ) {
                setcallscreen(true);
                setshowIncommingNxtscreen(true);
                setcalledagentscreen(true);
                setShowHold(true);
                setShowUnHold(false);
                setTransferCall(false);
                setmakingTransferCall(false);
                setConfrence(false);
                setMergeCall(true);
              } else {
                setcallscreen(true);
                setshowIncommingNxtscreen(true);
                setShowMute(true);
                setShowUnMute(false);
                setShowHold(true);
                setShowUnHold(false);
                setagentCallUnHold(false);
                setTransferCall(true);
                setmakingTransferCall(false);
                setConfrence(true);
                setMergeCall(false);
                setcalledagentscreen(false);
                setconfrencescreen(false);
              }
            } else {
              setSpinner(false);
              setShowVoiceCall(true);
              setshowphonedialer(false);
              setcontactId(responseData.contactId);
              setSkillSet(responseData.skillSet);
              localStorage.setItem("contactId", responseData.contactId);
              setshowIncommingscreen(false);
              setcallscreen(true);
              setshowIncommingNxtscreen(true);
              setShowMute(true);
              setShowUnMute(false);
              setShowHold(true);
              setShowUnHold(false);
              setagentCallUnHold(false);
              setTransferCall(true);
              setmakingTransferCall(false);
              setConfrence(true);
              setMergeCall(false);
              setcalledagentscreen(false);
              setconfrencescreen(false);
              if (localStorage.getItem("callActivate") == "true") {
                props.setinvoice(true);
                updateStatus("InCall"); //dcc api
                localStorage.setItem("callAttend", "true");
                localStorage.setItem("callActivate", "false");
                localStorage.setItem("callpresent", "false");
                if (localStorage.getItem("CallMadeFromDcc") == "true") {
                  createVoiceSession(responseData, "CallMadeFromDcc");
                } else {
                  setDialedNumberInc(responseData.callerId);
                  createVoiceSession(responseData, "NotCallMadeFromDcc");
                }
                reset();
                start();
                CallArrivaltime();
              }
            }
          }
        } else if (responseData.callType == "ConsultConference") {
          if (localStorage.getItem("agenttransConf")) {
            setSpinner(false);
            setshowIncommingscreen(false);
            setShowVoiceCall(true);
            setcallscreen(true);
            setshowIncommingNxtscreen(true);
            setShowMute(true);
            setShowUnMute(false);
            setShowHold(true);
            setShowUnHold(false);
            setagentCallUnHold(false);
            setTransferCall(true);
            setmakingTransferCall(false);
            setConfrence(true);
            setMergeCall(false);
            setcalledagentscreen(false);
            setconfrencescreen(false);
            if (localStorage.getItem("callAttend") == "false") {
              updateStatus("InCall");
              localStorage.setItem("callAttend", "true");
              createVoiceSession(responseData);
              reset();
              start();
            }
          } else {
            if (localStorage.getItem("agentcallType") == "transfer") {
              localStorage.setItem("agentcontactid", responseData.contactId);
              setconsultedContactId(responseData.contactId);
              setShowphonedialer2(false);
              setShowphonedialer3(false);
              setcallscreen(true);
              setshowIncommingNxtscreen(true);
              setcalledagentscreen(true);
              setShowMute(true);
              setShowUnMute(false);
              setShowHold(false);
              setShowUnHold(true);
              setagentCallHold(true);
              setagentCallUnHold(false);
              setTransferCall(false);
              setmakingTransferCall(true);
              setConfrence(false);
              setMergeCall(false);
            } else {
              localStorage.setItem("agentcontactid", responseData.contactId);
              setconsultedContactId(responseData.contactId);
              setShowphonedialer2(false);
              setShowphonedialer3(false);
              setcallscreen(true);
              setshowIncommingNxtscreen(true);
              setcalledagentscreen(true);
              setShowMute(true);
              setShowUnMute(false);
              setShowHold(false);
              setShowUnHold(true);
              setagentCallHold(true);
              setagentCallUnHold(false);
              setTransferCall(false);
              setmakingTransferCall(false);
              setConfrence(false);
              setMergeCall(true);
            }
          }
        }
      }
      if (responseData.event == "HELD") {
        if (responseData.callType == "Inbound") {
          setDialedNumberInc(responseData.callingDeviceID);
          localStorage.getItem("contactId");
          setcontactId(responseData.contactId);
          setcallscreen(true);
          setshowIncommingNxtscreen(true);
          setShowHold(false);
          setShowUnHold(true);
          setagentCallHold(true);
          setagentCallUnHold(false);
        } else if (responseData.callType == "Outbound") {
          if (localStorage.getItem("contactId") == responseData.contactId) {
            setShowHold(false);
            setShowUnHold(true);
          }
        } else if (responseData.callType == "ConsultConference") {
          setShowHold(false);
          setShowUnHold(true);
          setagentCallHold(false);
          setagentCallUnHold(true);
        }
      }
      if (responseData.event == "DROPPED") {
        console.log("DROPPED", responseData);
        pauseRingSound();
        props.setinvoice(false);
        setshowIncommingscreen(false);
        if (
          responseData.reason == "DEFAULT" ||
          responseData.reason == "OBSERVE"
        ) {
          if (responseData.contactId == localStorage.getItem("contactId")) {
            if (localStorage.getItem("callAttend") == "false") {
              updateStatus("Not Ready");
              localStorage.removeItem("callAttend");
              localStorage.removeItem("callActivate");
              localStorage.removeItem("callAttend");
              createVoiceSessionForNotAnsCall(responseData);
              localStorage.removeItem("contactId");
              return;
            }
            localStorage.removeItem("contactId");
            localStorage.removeItem("callType");
            localStorage.removeItem("agenttransConf");
            localStorage.removeItem("transfercontactId");
            localStorage.removeItem("ClickToCall");
            localStorage.removeItem("ClickeToCallPhoneNum");
            localStorage.removeItem("CallMadeFromDcc");
            localStorage.removeItem("showBarginButton");
            localStorage.setItem("callpresent", "true");
            setcontactId("");
            setshowIncommingscreen(false);
            setShowphonedialer2(false);
            setShowphonedialer3(false);
            setcallscreen(false);
            setshowIncommingNxtscreen(false);
            setconfrencescreen(false);
            setShowMute(false);
            setShowUnMute(false);
            setShowHold(false);
            setShowUnHold(false);
            setagentCallUnHold(false);
            setTransferCall(false);
            setmakingTransferCall(false);
            setConfrence(false);
            setMergeCall(false);
            pause();
            CallEndedtime();
            setShowVoiceCall(false);
            updateStatus("ACW");

            setendchatModalDialog(true);
          } else if (
            responseData.contactId == localStorage.getItem("agentcontactid")
          ) {
            localStorage.removeItem("agentcontactid");
            localStorage.removeItem("agentcallType");
            setshowIncommingscreen(false);
            setcallscreen(true);
            setshowIncommingNxtscreen(true);
            setcalledagentscreen(false);
            setTransferCall(true);
            setmakingTransferCall(false);
            setConfrence(true);
            setMergeCall(false);
            setShowphonedialer2(false);
            setShowphonedialer3(false);
            unhold_call();
          }
        } else if (responseData.reason == "TRANSFER_COMPLETE") {
          if (localStorage.getItem("agenttransConf")) {
            // incoming tranfer call
            localStorage.removeItem("contactId");
            setcallscreen(true);
            setshowIncommingNxtscreen(true);
            setcalledagentscreen(false);
            setShowMute(true);
            setShowUnMute(false);
            setShowHold(true);
            setShowUnHold(false);
            setagentCallUnHold(false);
            setTransferCall(true);
            setmakingTransferCall(false);
            setConfrence(true);
            setMergeCall(false);
            setcontactId(localStorage.getItem("mainContactId"));
            localStorage.setItem(
              "contactId",
              localStorage.getItem("mainContactId")
            );
            setShowphonedialer2(false);
            setShowphonedialer3(false);
            localStorage.removeItem("mainContactId");
            CreateDummyReport(responseData);
          } else {
            localStorage.removeItem("contactId");
            localStorage.removeItem("callType");
            localStorage.removeItem("mainContactId");
            localStorage.removeItem("agentcontactid");
            localStorage.removeItem("agenttransConf");
            localStorage.removeItem("transfercontactId");
            localStorage.removeItem("agentcallType");
            setcontactId("");
            setshowIncommingscreen(false);
            setShowphonedialer2(false);
            setShowphonedialer3(false);
            setcallscreen(false);
            setshowIncommingNxtscreen(false);
            setconfrencescreen(false);
            setShowMute(false);
            setShowUnMute(false);
            setShowHold(false);
            setShowUnHold(false);
            setagentCallUnHold(false);
            setTransferCall(false);
            setmakingTransferCall(false);
            setConfrence(false);
            setMergeCall(false);
            pause();
            setShowVoiceCall(false);
            setendchatModalDialog(true);
            updateStatus("ACW");
          }
        } else if (responseData.reason == "CONFERENCE_COMPLETE") {
          if (localStorage.getItem("agenttransConf")) {
            console.log("conferance who get");
            localStorage.removeItem("contactId");
            localStorage.setItem("InConferance", true);
            localStorage.removeItem("agentcallType");
            setconfrencescreen(true);
            setshowIncommingNxtscreen(false);
            setcalledagentscreen(false);
            setShowHold(false);
            setShowUnHold(false);
            setTransferCall(false);
            setmakingTransferCall(false);
            setConfrence(false);
            setMergeCall(false);
            setShowphonedialer2(false);
            setShowphonedialer3(false);
            setcontactId(localStorage.getItem("mainContactId"));
            localStorage.setItem(
              "contactId",
              localStorage.getItem("mainContactId")
            );
            CreateDummyReport(responseData);
            setShowphonedialer2(false);
            setShowphonedialer3(false);
          } else {
            console.log("conferance who made");
            localStorage.setItem("InConferance", true);
            localStorage.removeItem("agentcallType");
            localStorage.removeItem("agentcontactid");
            setconfrencescreen(true);
            setshowIncommingNxtscreen(false);
            setcalledagentscreen(false);
            setShowHold(false);
            setShowUnHold(false);
            setTransferCall(false);
            setmakingTransferCall(false);
            setConfrence(false);
            setMergeCall(false);
            setShowphonedialer2(false);
            setShowphonedialer3(false);
          }
        } else {
          if (localStorage.getItem("callAttend") == "false") {
            updateStatus("Not Ready");
            localStorage.removeItem("callAttend");
            localStorage.removeItem("callActivate");
            localStorage.removeItem("callAttend");
            createVoiceSessionForNotAnsCall(responseData);
          }
        }
      }
    });
  };

  const onError = (error) => {
    console.log("error", error);
    toast.error("Voice Socket Issue", {
      position: "top-right",
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: false,
      progress: undefined,
      theme: "light",
    });
    setTimeout(() => {
      // logoutByDomainFirst();
    }, 2000);
  };

  const logoutByDomainFirst = async () => {
    await axios
      .post(
        AvcUrl +
          `/voice/cct/agent/${localStorage.getItem(
            "agentLoginTerminalId"
          )}/logout/${localStorage.getItem("agentLoginTerminalId")}`,
        {},
        {
          headers: {
            ssoToken: localStorage.getItem("ssoToken"),
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        if (res.data.status == "OK") {
          logoutByDomainSecond();
        } else {
          props.setShowingStatusVoice("Not Connected");
          ErrorNotification("Voice LogOut", res.data.message);
        }
      })
      .catch((error) => {
        props.setShowingStatusVoice("Not Connected");
        ErrorNotification("Voice LogOut", error.message);
      });
  };
  const logoutByDomainSecond = async () => {
    const agentUsername = localStorage.getItem("agentUsername");
    await axios
      .post(
        AvcUrl + "/voice/cct/logout?username=" + agentUsername,
        {},
        {
          headers: {
            ssoToken: localStorage.getItem("ssoToken"),
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        if (res.data.status == "OK") {
          props.setShowingStatusVoice("Not Connected");
          localStorage.removeItem("ssoToken");
          localStorage.removeItem("agentLoginTerminalId");
          localStorage.removeItem("agentUsername");
          localStorage.removeItem("enableSDK");
        } else {
          props.setShowingStatusVoice("Not Connected");
          localStorage.removeItem("ssoToken");
          localStorage.removeItem("agentLoginTerminalId");
          localStorage.removeItem("agentUsername");
          localStorage.removeItem("enableSDK");
          ErrorNotification("Voice LogOut", res.data.message);
        }
      })
      .catch((err) => {
        props.setShowingStatusVoice("Not Connected");
        localStorage.removeItem("ssoToken");
        localStorage.removeItem("agentLoginTerminalId");
        localStorage.removeItem("agentUsername");
        localStorage.removeItem("enableSDK");
        ErrorNotification("Voice LogOut", err.message);
      });
  };

  const onDisconnectWebSocket = () => {
    stompClient.disconnect();
  };

  const CallArrivaltime = () => {
    var currentDate = new Date();
    var arrivaltime = currentDate.toLocaleTimeString();
    console.log("CallArrivaltime time: " + arrivaltime);
  };
  const CallEndedtime = () => {
    var currentDate = new Date();
    var CallEndedtime = currentDate.toLocaleTimeString();
    console.log("CallEndedtime time: " + CallEndedtime);
  };
  const CustomerNameApi = async (phonenumber) => {
    let datas = {
      phone: phonenumber,
    };
    await axios
      .post(BaseUrl + "/users/customername", datas, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
          "Content-Type": "application/json",
          tenantid: localStorage.getItem("TenantId"),
        },
      })
      .then((res) => {
        setDialedNumberInc(res.data.data);
      })
      .catch((err) => {});
  };
  const tranferConferanceUpdate = async (phonenumber) => {
    let datas = {
      voice_contactId: localStorage.getItem("transfercontactId"),
      phonenumber,
    };
    await axios
      .post(BaseUrl + "/users/voicetransferupdate", datas, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
          "Content-Type": "application/json",
          tenantid: localStorage.getItem("TenantId"),
        },
      })
      .then((res) => {
        props.setChatRefresh(true);
        localStorage.removeItem("transfercontactId");
      });
  };
  const handleOpenCrmUrl = async () => {
    let body = {
      phonenumber: dailedNumberInc,
      skillset: skillset,
      channel: "voice",
      callid: localStorage.getItem("contactId"),
      direction: "INBOUND",
    };
    await axios
      .post(BaseUrl + "/ticket/crmscreenpop", body, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
          "Content-Type": "application/json",
          tenantId: localStorage.getItem("TenantId"),
        },
      })
      .then((res) => {
        console.log("newincomingCrmpopupApi", res);

        window.open(res.data.data, "_blank");
      })
      .catch((error) => {
        console.log("error", error);
        toast.warning("screen pop url not configured");
      });

    answerIncCall();
  };
  const redialtheNumber = () => {
    setDialedNumber(localStorage.getItem("redialedNumber"));
  };
  const makeCall = () => {
    localStorage.setItem("callActivate", "true");
    localStorage.setItem("CallMadeFromDcc", "true");
    if (agentLoginTerminalId == dailedNumber)
      return alert("Don't Enter Same Extension Number You LoggedIn With");
    if (dailedNumber == "") return alert("Please enter a valid Number");

    setDialedNumberInc(dailedNumber);
    localStorage.setItem("redialedNumber", dailedNumber);
    localStorage.setItem("dailedNumber", dailedNumber);
    let ssToken = localStorage.getItem("ssoToken");
    axios
      .post(
        AvcUrl +
          `/voice/terminal/${agentLoginTerminalId}/createContact/sip:${agentLoginTerminalId}@${
            localStorage.getItem("TenantId") ==
            "788205e1-6116-4c09-904a-5b641d09de0f"
              ? VoiceDomainNamePure
              : VoiceDomainName
          }/sip:${dailedNumber}@${
            localStorage.getItem("TenantId") ==
            "788205e1-6116-4c09-904a-5b641d09de0f"
              ? VoiceDomainNamePure
              : VoiceDomainName
          }`,
        {},
        {
          headers: {
            ssoToken: ssToken,
          },
        }
      )
      .then((res) => {
        if (res.data.status == "OK") {
          setDialedNumber("");
        } else {
          toast.warn("Please Try Again After Some Time", {
            position: "top-right",
            autoClose: 500,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
            theme: "light",
          });
        }
      })
      .catch((err) => {
        toast.warn("Please Try Again After Some Time", {
          position: "top-right",
          autoClose: 500,
          hideProgressBar: true,
          closeOnClick: false,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
          theme: "light",
        });
      });
  };
  const rejectIncCall = () => {
    if (avayaplatform == "AACC") {
      let ssToken = localStorage.getItem("ssoToken");
      axios
        .post(
          AvcUrl +
            `/voice/terminal/${agentLoginTerminalId}/disconnect/${contactId}`,
          {},
          {
            headers: {
              ssoToken: ssToken,
            },
          }
        )
        .then((res) => {})
        .catch((err) => {});
    }
  };
  const answerIncCall = async (e) => {
    if (avayaplatform == "AACC") {
      setSpinner(true);
      let ssToken = localStorage.getItem("ssoToken");
      axios
        .post(
          `${AvcUrl}/voice/terminal/${agentLoginTerminalId}/answer/${contactId}`,
          {},
          {
            headers: {
              ssoToken: ssToken,
            },
          }
        )
        .then(async (res) => {
          if ((res.data.status = "OK")) {
            setSpinner(false);
          }
        })
        .catch((err) => {
          console.error(err);
          setSpinner(false);
        });
    }
  };
  const createVoiceSession = async (value, value2) => {
    let tokenagent = await JSON.parse(localStorage.getItem("tokenAgent"));
    var agent_extension = localStorage.getItem("AvayaUsername");
    let datas = {
      name: localStorage.getItem("CampaignCallClicktoCallName")
        ? localStorage.getItem("CampaignCallClicktoCallName")
        : "",
      email_id: "",
      phone:
        value2 == "CallMadeFromDcc"
          ? localStorage.getItem("dailedNumber")
          : value.callingDeviceID,
      // phone:
      //   localStorage.getItem("agentLoginTerminalId") == value.calledDeviceID
      //     ? value.callingDeviceID
      //     : value.calledDeviceID,
      channel: "voice",
      latitude: "",
      longitute: "",
      skillset: value.skillSet,
      language: "English",
      complaint: "",
      agent_id: tokenagent.id,
      agent_extension: agent_extension,
      direction: value.callType,
      contactId: value.contactId,
      UUID_contactId: value.contactId,
      UUID_externalContactId: value.externalContactId,
      UUID_calledDeviceID: value.calledDeviceID,
      UUID_callingDeviceID: value.UUID_callingDeviceID,
      UUID_callingAgentName: value.callingAgentName,
      UUID_skillSet: value.skillSet,
    };
    await axios
      .post(BaseUrl + "/users/callcreateSession", datas, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
          "Content-Type": "application/json",
          tenantid: localStorage.getItem("TenantId"),
        },
      })
      .then(async (res) => {
        if (res.data.status == true) {
          let voiceuser = res.data.data[0];
          const datas = JSON.parse(localStorage.getItem("tokenAgent"));
          try {
            await axios
              .post(
                `${BaseUrl}/users/allUsers?agent_id=${datas.id}`,
                {},
                {
                  headers: {
                    Authorization:
                      "Bearer " + localStorage.getItem("access_token"),
                    "Content-Type": "application/json",
                    tenantId: localStorage.getItem("TenantId"),
                  },
                }
              )
              .then(async (res) => {
                props.setcontactlist(res.data);
                props.setVoiceSessionId(voiceuser.chat_session_id);
                props.setExternalChatData(voiceuser);
                props.setAcceptChatActive(true);
                props.setsidebarVal("Chat");
                navigate("/main/Chat");
                if (localStorage.getItem("ClickToCall") == "true") {
                  let body = {
                    phonenumber: localStorage.getItem("ClickeToCallPhoneNum"),
                    skillset: "customer service",
                    channel: "voice",
                    type: localStorage.getItem("type"),
                    reg_no: localStorage.getItem("Contactreg_no"),
                    contact_id: localStorage.getItem("ContactVoiceId"),
                    callid: localStorage.getItem("contactId"),
                    direction: "OUTBOUND",
                  };
                  await axios
                    .post(BaseUrl + "/ticket/crmscreenpop", body, {
                      headers: {
                        Authorization:
                          "Bearer " + localStorage.getItem("access_token"),
                        "Content-Type": "application/json",
                        tenantId: localStorage.getItem("TenantId"),
                      },
                    })
                    .then((res) => {
                      window.open(res.data.data);
                      toast.success("screen pop url generated", toaststyle);
                    })
                    .catch((error) => {
                      toast.warning("screen pop url not generated", toaststyle);
                    });
                }
              })
              .catch((err) => {});
          } catch (error) {}
        }
      });
  };
  const createVoiceSessionForNotAnsCall = async (value) => {
    let tokenagent = await JSON.parse(localStorage.getItem("tokenAgent"));
    var agent_extension = localStorage.getItem("AvayaUsername");
    let datas = {
      name: "",
      email_id: "",
      phone:
        value.callingDeviceID == null
          ? localStorage.getItem("incomingNumber")
          : value.callingDeviceID,
      channel: "voice",
      latitude: "",
      longitute: "",
      skillset: value.skillSet,
      language: "English",
      complaint: "",
      agent_id: tokenagent.id,
      agent_extension: agent_extension,
      direction: value.callType,
      contactId: value.contactId,
      UUID_contactId: value.contactId,
      UUID_externalContactId: value.externalContactId,
      UUID_calledDeviceID: value.calledDeviceID,
      UUID_callingDeviceID: value.UUID_callingDeviceID,
      UUID_callingAgentName: value.callingAgentName,
      UUID_skillSet: value.skillSet,
      isabandoned: true,
    };
    await axios
      .post(BaseUrl + "/users/callcreateSession", datas, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
          "Content-Type": "application/json",
          tenantid: localStorage.getItem("TenantId"),
        },
      })
      .then(async (res) => {
        if (res.data.status == true) {
          localStorage.removeItem("incomingNumber");
        }
      });
  };
  const toggleclose = () => {
    props.setshowphonedialer(false);
    setDialedNumber(null);
  };
  const unhold_call = () => {
    if (avayaplatform == "AACC") {
      axios
        .post(
          AvcUrl +
            `/voice/terminal/${agentLoginTerminalId}/unhold/` +
            localStorage.getItem("contactId"),
          {},
          {
            headers: {
              ssoToken: localStorage.getItem("ssoToken"),
            },
          }
        )
        .then(async (res) => {
          if ((res.data.status = "OK")) {
            console.log("res", res);
          }
        })
        .catch((err) => {
          console.error(err);
        });
      axios.post(
        BaseUrl + "/reports/dummyreport",
        {
          type: "unhold",
          phonenumber: dailedNumberInc,
          contactId: contactId,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantid: localStorage.getItem("TenantId"),
          },
        }
      );
    }
  };
  const handleKeyPress = (event) => {
    if (event.keyCode === 13 || event.which === 13) {
      makeCall();
    }
  };
  const CreateDummyReport = (value) => {
    var client = JSON.parse(localStorage.getItem("client"));
    axios.post(
      BaseUrl + "/reports/dummyreport",
      {
        type: "completetransfer",
        phonenumber: dailedNumberInc,
        contactId: value.contactId,
        chatsessionid: client.chat_session_id,
      },
      {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
          "Content-Type": "application/json",
          tenantid: localStorage.getItem("TenantId"),
        },
      }
    );
  };
  const endChat = () => {
    console.log("interaction end no pop up will display");
    const client = JSON.parse(localStorage.getItem("client"));
    let userId = JSON.parse(localStorage.getItem("tokenAgent"));
    let agentId = userId.id;
    let data = {
      chat_session_id: client.chat_session_id,
      chatendby: "Agent",
      reason: "Released",
      comment: "Completed",
      agent_id: agentId,
    };

    axios
      .post(BaseUrl + "/message/endchat", data, {
        headers: {
          tenantId: localStorage.getItem("TenantId"),
        },
      })
      .then(async (res) => {
        if (res.data.success == true) {
          const datas = JSON.parse(localStorage.getItem("tokenAgent"));
          try {
            await axios
              .post(
                `${BaseUrl}/users/allUsers?agent_id=${datas.id}`,
                {},
                {
                  headers: {
                    Authorization:
                      "Bearer " + localStorage.getItem("access_token"),
                    "Content-Type": "application/json",
                    tenantId: localStorage.getItem("TenantId"),
                  },
                }
              )
              .then((data) => {
                props.setcontactlist(data.data);
              });
          } catch (error) {}
          localStorage.removeItem("client");
          props.setshowExternalChat(false);
          toast.success("Interaction Ended Successfully", {
            position: "top-right",
            autoClose: 500,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
            theme: "light",
          });
          localStorage.removeItem("callActivate");
          localStorage.removeItem("type");
          localStorage.removeItem("ContactVoiceId");
          localStorage.removeItem("Contactreg_no");
          updateStatus("Ready");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const updateStatus = async (value) => {
    if (!value) return;
    let data = await JSON.parse(localStorage.getItem("tokenAgent"));
    await axios
      .post(
        BaseUrl + "/users/updateAgentStatus/",
        {
          status: value,
          userId: data.user_id,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        if (res.data.status) {
          if (value == "Ready") {
            props.setReadyButton(true);
            props.setShowingStatus(value);
            localStorage.setItem("AgentStatus", value);
            props.setShowingStatusClass("showStatus");
            if (props.showingStatusVoice == "Not Connected") {
            } else {
              props.changeStatusVoice("Ready", "Ready");
            }
          } else {
            props.setReadyButton(true);
            props.setShowingStatus(value);
            localStorage.setItem("AgentStatus", value);
            props.setShowingStatusClass("showStatusRed");
            if (props.showingStatusVoice == "Not Connected") {
            } else {
              props.changeStatusVoice("Not Ready", "Not Ready");
            }
          }
        }
      })
      .catch((err) => {});
  };

  const ErrorNotification = (headerMsg, msg) => {
    const randomChars = Math.random().toString(36).substring(2, 10);
    const timestamp = new Date().getTime().toString(36);
    const randomId = randomChars + timestamp;
    var newNotification = {
      id: randomId,
      username: headerMsg,
      client_msg: msg,
      from_id: "voice api",
      chatType: "Error Message",
    };
    props.updateNotification(newNotification);
  };

  return (
    <>
      <audio ref={myRef} src={soundfile} />

      <Draggable handle=".handle">
        <nav
          className="dialer-main"
          style={{
            display: showphonedialer ? "block" : "none",
          }}
        >
          <div className="filter shadow">
            <div className="icons-dialer">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <div className="user-dial position-relative handle">
                  <p style={{ fontSize: "13px", cursor: "pointer" }}>
                    Ext:{localStorage.getItem("agentLoginTerminalId")}
                  </p>
                </div>
                <div className="dismiss ">
                  <span
                    className="material-symbols-outlined"
                    id="toggle-close"
                    onClick={() => {
                      toggleclose();
                    }}
                    style={{ fontSize: "20px" }}
                  >
                    cancel
                  </span>
                </div>
              </div>
            </div>
            <div className="dialer-sub">
              <div className="inputHolder d-flex align-items-center">
                <input
                  className="form-control dialerInput"
                  type="text"
                  id=""
                  value={dailedNumber}
                  onChange={(e) =>
                    setDialedNumber(e.target.value.replace(/[^\d]/, ""))
                  }
                  onKeyDown={(event) => {
                    return /[0-9]/i.test(event.key);
                  }}
                  onKeyPress={handleKeyPress}
                />

                <button
                  className="dial-bck"
                  id="number"
                  onClick={() =>
                    setDialedNumber((dailedNumber) =>
                      dailedNumber.slice(0, dailedNumber.length - 1)
                    )
                  }
                >
                  <i
                    className="fa-solid fa-delete-left"
                    style={{ fontSize: "21px" }}
                  ></i>
                </button>
                <i
                  className="fa-solid fa-arrow-rotate-left mx-2"
                  id="number"
                  style={{ fontSize: "19px", color: "#707070" }}
                  onClick={() => {
                    redialtheNumber();
                  }}
                ></i>
              </div>
              <div className="dial-pad">
                <div className="dial-pad-sub">
                  <ul className="icons p-0 m-0">
                    <li
                      id="one"
                      value="1"
                      className="num"
                      onClick={() =>
                        setDialedNumber((dailedNumber) => `${dailedNumber}1`)
                      }
                    >
                      1
                    </li>
                    <li
                      id="two"
                      value="2"
                      onClick={() =>
                        setDialedNumber((dailedNumber) => `${dailedNumber}2`)
                      }
                    >
                      2
                    </li>
                    <li
                      id="three"
                      value="3"
                      onClick={() =>
                        setDialedNumber((dailedNumber) => `${dailedNumber}3`)
                      }
                    >
                      3
                    </li>
                    <li
                      id="four"
                      value="4"
                      onClick={() =>
                        setDialedNumber((dailedNumber) => `${dailedNumber}4`)
                      }
                    >
                      4
                    </li>
                    <li
                      id="five"
                      value="5"
                      onClick={() =>
                        setDialedNumber((dailedNumber) => `${dailedNumber}5`)
                      }
                    >
                      5
                    </li>
                    <li
                      id="six"
                      value="6"
                      onClick={() =>
                        setDialedNumber((dailedNumber) => `${dailedNumber}6`)
                      }
                    >
                      6
                    </li>
                    <li
                      id="seven"
                      value="7"
                      onClick={() =>
                        setDialedNumber((dailedNumber) => `${dailedNumber}7`)
                      }
                    >
                      7
                    </li>
                    <li
                      id="eight"
                      value="8"
                      onClick={() =>
                        setDialedNumber((dailedNumber) => `${dailedNumber}8`)
                      }
                    >
                      8
                    </li>
                    <li
                      id="nine"
                      value="9"
                      onClick={() =>
                        setDialedNumber((dailedNumber) => `${dailedNumber}9`)
                      }
                    >
                      9
                    </li>
                    <li
                      className="star2"
                      id="*"
                      value="astrick"
                      onClick={() =>
                        setDialedNumber((dailedNumber) => `${dailedNumber}*`)
                      }
                    >
                      *
                    </li>
                    <li
                      className="d-flex flex-column"
                      id="zero"
                      value="0"
                      onClick={() =>
                        setDialedNumber((dailedNumber) => `${dailedNumber}0`)
                      }
                    >
                      0
                    </li>
                    <li
                      className="hash0"
                      id="hash"
                      value="#"
                      onClick={() =>
                        setDialedNumber((dailedNumber) => `${dailedNumber}#`)
                      }
                    >
                      #
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <nav className="d-flex justify-content-center dial-nav">
              <button
                className="dialer-btn-main"
                id="call"
                onClick={() => {
                  makeCall();
                }}
              >
                <i
                  className="fa-solid fa-phone"
                  style={{ fontSize: "17px" }}
                ></i>
              </button>

              <ul className="nav nav-pills position-relative">
                <li className="nav-item"></li>
                <li className="nav-item"></li>
                <li className="nav-item nav-width"></li>
                <li className="nav-item"></li>
                <li className="nav-item"></li>
              </ul>
            </nav>
          </div>
        </nav>
      </Draggable>

      {/* incoming call screen */}
      <Draggable handle=".handle">
        <div
          className="incomecall-phone  p-2"
          style={{ display: showIncommingscreen ? "block" : "none" }}
        >
          <div className="image-paragraph">
            <div
              className=" d-flex justify-content-center align-items-center"
              style={{
                width: "30px",
                height: "30px",
                borderRadius: "50%",
                color: "aliceblue",
                fontSize: "18px",
                fontWeight: "bold",
                position: "relative",
                boxShadow:
                  "rgb(0 0 0 / 0%) 0px 1px 3px, rgb(0 0 0 / 14%) 0px 1px 2px",
              }}
            >
              <img
                src={voiceIcon}
                style={{
                  height: "23px",
                  width: "23px",
                  margin: "auto",
                }}
              />
            </div>
            <p>Incoming Call from {dailedNumberInc}</p>
          </div>

          <div className="row mt-2 mb-4 list-details">
            <div className="col-6">
              <p>Caller Number :</p>
            </div>
            <div className="col-6">
              <p>{dailedNumberInc ? dailedNumberInc : ""}</p>
            </div>
            <div className="col-6">
              <p>Skillset :</p>
            </div>
            <div className="col-6">
              <p>{skillset ? skillset : ""}</p>
            </div>
          </div>
          <div className="request-button">
            <button
              onClick={() => answerIncCall()}
              type="button "
              className="btn btn-success button mx-3"
              id="accept_client_chat"
              style={{ width: "50px" }}
            >
              {spinner ? (
                <div
                  className="spinner-border"
                  role="status"
                  style={{ height: "1rem", width: "1rem" }}
                >
                  <span className="sr-only">Loading...</span>
                </div>
              ) : (
                <p style={{ color: "#ffff" }}>
                  <i className="fa-solid fa-phone"></i>
                </p>
              )}
            </button>

            <button
              onClick={() => rejectIncCall()}
              type="button"
              className="btn btn-danger button"
              id="reject_client_chat"
              style={{ width: "50px" }}
            >
              <p style={{ color: "#ffff" }}>
                <i className="fa-solid fa-phone-slash"></i>
              </p>
            </button>

            {JSON.parse(localStorage.getItem("permission")).map((module) => {
              if (module.moduleName === "Crm") {
                const crmScreen = module.screen.find(
                  (item) => item.screenId === "CRM" && item.read && item.write
                );

                if (crmScreen) {
                  return (
                    <button
                      type="button "
                      className="btn btn-success button mx-3"
                      id="accept_client_chat"
                      style={{ width: "50px" }}
                      onClick={() => {
                        handleOpenCrmUrl();
                      }}
                    >
                      <p style={{ color: "#ffff" }}>CRM</p>
                    </button>
                  );
                } else {
                  return null;
                }
              } else {
                return null;
              }
            })}
          </div>
        </div>
      </Draggable>

      {JSON.parse(localStorage.getItem("permission")).map((module) => {
        if (module.moduleName === "vioce") {
          const crmScreen = module.screen.find(
            (item) =>
              item.screenId === "AUTOWRAPUP" &&
              item.read == true &&
              item.write == true
          );

          if (crmScreen) {
            return (
              <>
                {endchatModalDialog && (
                  <EndChatModelForPopCall
                    OpenDialog={endchatModalDialog}
                    setendchatModalDialognew={closeModel}
                  />
                )}
              </>
            );
          } else {
            return (
              <>
                {endchatModalDialog && (
                  <EndChatModel
                    OpenDialog={endchatModalDialog}
                    handleClose={() => setendchatModalDialog(false)}
                  />
                )}
              </>
            );
          }
        }
      })}
    </>
  );
};

export default connect(mapStateToProps, {
  setSkillSet,
  setDialedNumberInc,
  setagentDialedNumber,
  setshowphonedialer,
  setShowphonedialer2,
  setShowphonedialer3,
  setshowIncommingscreen,
  setcallscreen,
  setshowIncommingNxtscreen,
  setcalledagentscreen,
  setconfrencescreen,
  setShowMute,
  setShowUnMute,
  setAgentShowMute,
  setAgentShowUnMute,
  setShowHold,
  setShowUnHold,
  setagentCallHold,
  setagentCallUnHold,
  setTransferCall,
  setmakingTransferCall,
  setConfrence,
  setMergeCall,
  setcontactId,
  setconsultedContactId,
  setCallId,
  setAcceptChatActive,
  setExternalChatData,
  setVoiceSessionId,
  setvoiceseconds,
  setvoiceminutes,
  setvoicehours,
  setsidebarVal,
  setShowNotification,
  setShowUserProfile,
  setChatRefresh,
  setShowVoiceCall,
  setcontactlist,
  setShowingStatusVoice,
  updateNotification,
  setReadyButton,
  setShowingStatus,
  setShowingStatusClass,
  setshowExternalChat,
})(Sdk);
